<template>
	<div class="content">
			<div class="row">
				<div class="col-12">
					<div class="row">
						<div class="col-2"><h5>Crear Cliente</h5></div>
						<div class="col-8 text-center"><h5>{{ mensaje }}</h5></div>
						<div class="col-2 text-right">
							<b-button size="sm" variant="primary" @click="guardar">Guardar</b-button>&nbsp;
							<b-button size="sm" variant="secondary" @click="cerrar">Cerrar</b-button>
						</div>
					</div>
					<hr style="margin-top: 10px; margin-bottom: 5px" />
				</div>
			</div>
			<div class="row data">
				<div class="col-12 formulario">
					<b-form id="agregarClienteForm">
						<div class="row">
							<div class="col-6">
								<div class="row">
									<div class="col-12"><b>Datos Empresa</b> <hr class="linea" /></div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-4">
										<small>R.U.T.</small>
										<b-input id="CLIENT_TAX_CODE" name="CLIENT_TAX_CODE" size="sm" :state="validado.CLIENT_TAX_CODE" placeholder="12345678-9" required upper />
									</div>
									<div class="col-8">
										<small>Razón Social</small>
										<b-input id="CLIENT_NAME" name="CLIENT_NAME" size="sm" :state="validado.CLIENT_NAME" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-12">
										<small>Grupo Económico</small>
										<b-input id="GRUPO_ECONOMICO" name="GRUPO_ECONOMICO" size="sm" />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-6">
										<small>Client ID</small>
										<b-input id="CLIENT_ID" name="CLIENT_ID" size="sm" />
									</div>
									<div class="col-6">
										<small>Client ID Madre</small>
										<b-input id="CLIENT_ID_MADRE" name="CLIENT_ID_MADRE" size="sm" v-model="id" :state="validado.CLIENT_ID_MADRE" required largo="32" />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-12">
										<small>Giro</small>
										<b-select id="GIRO" name="GIRO" size="sm" value="null" :options="getGiros" value-field="id" text-field="tag" :state="validado.GIRO" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-4">
										<small>Last Event Type</small>
										<b-select id="LAST_EVENT_TYPE" name="LAST_EVENT_TYPE" size="sm" :options="getLastEventType" value-field="id" text-field="tag" />
									</div>
									<div class="col-4">
										<small>Categoría</small>
										<b-select id="CATEGORIA" name="CATEGORIA" size="sm" :options="getCategorias" value-field="id" text-field="tag" />
									</div>
									<div class="col-4">
										<small>Billing Period</small>
										<b-select id="BILLING_PERIOD" name="BILLING_PERIOD" size="sm" value="null" :options="getBillingPeriod" value-field="id" text-field="tag" :state="validado.BILLING_PERIOD" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-4">
										<small>Size</small>
										<b-select id="SIZE" name="SIZE" size="sm" :options="getSize" value-field="id" text-field="tag" />
									</div>
									<div class="col-8">
										<small>Sector</small>
										<b-select id="SECTOR" name="SECTOR" size="sm" :options="getSector" value-field="id" text-field="tag" />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-6">
										<small>City</small>
										<b-input id="CITY" name="CITY" size="sm" />
									</div>
									<div class="col-6">
										<small>County</small>
										<b-input id="COUNTY" name="COUNTY" size="sm" />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-4">
										<small>Registered Users</small>
										<b-input id="REGISTERED_USERS" name="REGISTERED_USERS" size="sm" />
									</div>
									<div class="col-4">
										<small>Potential Users</small>
										<b-input id="POTENTIAL_USERS" name="POTENTIAL_USERS" size="sm" />
									</div>
									<div class="col-4">
										<small>Deal Value</small>
										<b-input id="DEAL_VALUE" name="DEAL_VALUE" size="sm" />
									</div>
								</div>
							</div>
							<div class="col-6">
								<div class="row">
									<div class="col-12"><b>Datos de Facturación</b> <hr class="linea" /></div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-6">
										<small>Correo</small>
										<b-input id="CORREOS_FAC" name="CORREOS_FAC" size="sm" :state="validado.CORREOS_FAC" required />
									</div>
									<div class="col-6">
										<small>Dirección</small>
										<b-input id="CLIENT_ADDRESS" name="CLIENT_ADDRESS" size="sm" :state="validado.CLIENT_ADDRESS" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-6">
										<small>Comuna</small>
										<b-select id="CLIENT_CITY" name="CLIENT_CITY" size="sm" value="null" :options="getComunas" value-field="id" text-field="tag" :state="validado.CLIENT_CITY" required />
									</div>
									<div class="col-6">
										<small>Ciudad</small>
										<b-input id="CIUDAD_FAC" name="CIUDAD_FAC" size="sm" :state="validado.CIUDAD_FAC" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-8">
										<small>Detalle CC</small>
										<b-input id="DETALLE_CC_FACTURACION" name="DETALLE_CC_FACTURACION" size="sm" />
									</div>
									<div class="col-4">
										<small>Recurrente</small>
										<b-select id="RECURRENTE" name="RECURRENTE" size="sm" value="null" :options="getSioNo" value-field="id" text-field="tag" :state="validado.RECURRENTE" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-4">
										<small>N. OC</small>
										<b-input id="N_OC" name="N_OC" size="sm" :state="validado.N_OC" />
									</div>
									<div class="col-8">
										<small>Vencimiento OC</small>
										<b-input-group size="sm">
											<date-picker id="VENCIMIENTO_OC" name="VENCIMIENTO_OC" :value="vencimiento"
												:config="{ format: 'MM-DD-YYYY', locale: 'es' }" placeholder="Ingresar Fecha">
											</date-picker>
										</b-input-group>
									</div>
								</div>
								<div class="row">&nbsp;</div>
								<div class="row">
									<div class="col-12"><b>Detalles de Facturación</b> <hr class="linea" /></div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-6">
										<small>Especial</small>
										<b-select id="ESPECIAL" name="ESPECIAL" size="sm" v-model="especial" :options="getSioNo" value-field="id" text-field="tag" :state="validado.ESPECIAL" required />
									</div>
									<div class="col-6">
										<small>Centro Costo</small>
										<b-select id="CENTRO_COSTO" name="CENTRO_COSTO" size="sm" v-model="ccosto" :options="getSioNo" value-field="id" text-field="tag" :state="validado.CENTRO_COSTO" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-4">
										<small>Orden Compra</small>
										<b-select id="ORDEN_COMPRA" name="ORDEN_COMPRA" size="sm" v-model="ocompra" :options="getSioNo" value-field="id" text-field="tag" :state="validado.ORDEN_COMPRA" required />
									</div>
									<div class="col-4">
										<small>Desglose</small>
										<b-select id="DESGLOSE" name="DESGLOSE" size="sm" v-model="desglose" :options="getSioNo" value-field="id" text-field="tag" :state="validado.DESGLOSE" required />
									</div>
									<div class="col-4">
										<small>HES</small>
										<b-select id="HES" name="HES" size="sm" v-model="hes" :options="getSioNo" value-field="id" text-field="tag" :state="validado.HES" required />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-6">
										<small>Método Pago</small>
										<b-select id="METODO_PAGO" name="METODO_PAGO" size="sm" value="null" :options="getMetodoPago" value-field="id" text-field="tag" :state="validado.METODO_PAGO" required />
									</div>
									<div class="col-6">
										<small>Payment Terms</small>
										<b-select id="PAYMENT_TERMS" name="PAYMENT_TERMS" size="sm" value="null" :options="getPaymentTerms" value-field="id" text-field="tag" :state="validado.PAYMENT_TERMS" required />
									</div>
								</div>
							</div>
						</div>
						<div class="row">&nbsp;</div>
						<div class="row">
							<div class="col-12">
								<div class="row">
									<div class="col-12"><b>Contactos</b> <hr class="linea" /></div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-3">
										<small>Nombre Admin</small>
										<b-input id="NOMBRE_ADMIN" name="NOMBRE_ADMIN" size="sm" />
									</div>
									<div class="col-3">
										<small>Correo Admin</small>
										<b-input id="CORREO_ADMIN" name="CORREO_ADMIN" size="sm" />
									</div>
									<div class="col-3">
										<small>Teléfono Admin 1</small>
										<b-input id="TELEFONO_ADMIN" name="TELEFONO_ADMIN" size="sm" />
									</div>
									<div class="col-3">
										<small>Teléfono Admin 2</small>
										<b-input id="TELEFONO_ADMIN2" name="TELEFONO_ADMIN2" size="sm" />
									</div>
								</div>
								<p class="separador" />
								<div class="row">
									<div class="col-3">
										<small>Nombre Cobranza</small>
										<b-input id="NOMBRE_COB" name="NOMBRE_COB" size="sm" />
									</div>
									<div class="col-3">
										<small>Correo Cobranza 1</small>
										<b-input id="CORREO_COB" name="CORREO_COB" size="sm" />
									</div>
									<div class="col-3">
										<small>Teléfono Cobranza 1</small>
										<b-input id="TELEFONO_COB" name="TELEFONO_COB" size="sm" />
									</div>
									<div class="col-3">
										<small>Teléfono Cobranza 2</small>
										<b-input id="TELEFONO_COB2" name="TELEFONO_COB2" size="sm" />
									</div>
								</div>
							</div>
						</div>
						<div class="row">&nbsp;</div>
						<div class="row">
							<div class="col-12"><b>Responsables Cabify</b> <hr class="linea" /></div>
						</div>
						<p class="separador" />
						<div class="row">
							<div class="col-4">
								<small>Hunter Rep.</small>
								<b-select id="SALES_REP" name="SALES_REP" size="sm" :options="getHunterRep" value-field="id" text-field="tag" />
							</div>
							<div class="col-4">
								<small>Farmer Rep.</small>
								<b-select id="SOPORTE" name="SOPORTE" size="sm" :options="getFarmerRep" value-field="id" text-field="tag" />
							</div>
							<div class="col-2">
								<small>Collection</small>
								<b-select id="COLLECTION" name="COLLECTION" size="sm" value="null" :options="getCollection" value-field="id" text-field="tag" :state="validado.COLLECTION" required />
							</div>
						</div>
						<p class="separador" />
					</b-form>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import moment from "moment"
	import $ from "jquery"
	import listas from "./listas.json"
	import ValidaRut from "./ValidaRut.js"


	export default {
		name: "CrearSimple",
		props: {
			clientes: Array,
			onCerrar: Function,
		},
		data() {
			return {
				mensaje: "",
				validado: {}, // Objeto que contiene la validacion de cada campo obligatorio
				id: "",
				especial: null,
				ccosto: null,
				ocompra: null,
				desglose: null,
				hes: null,
				vencimiento: "",
				campos: [ "last_event_type", "soporte", "sales_rep", "client_type", "client_kind", "client_id", "client_id_madre", "client_name", "client_tax_code", "billing_pe    riod", "payment_terms", "size", "sector", "starred", "city", "county", "country", "registered_users", "potential_users", "charge_code_format", "charge_code_required", "metodo_pa    go", "using_labels", "deal_value", "categoria", "grupo_economico", "centro_costo", "orden_compra", "desglose", "hes", "especial", "nombre_admin", "correo_admin", "telefono_admin    ", "telefono_admin2", "nombre_cob", "correo_cob", "telefono_cob", "telefono_cob2", "correos_fac", "giro", "client_address", "client_city", "ciudad_fac", "detalle_cc_facturacion"    , "collection", "vencimiento_oc", "n_oc", "recurrente" ],
			}
		},
		watch: {
			especial: function(value) {

				if (value == "NO") {

					this.ccosto = "NO"
					this.ocompra = "NO"
					this.desglose = "NO"
					this.hes = "NO"
				} else {

					this.ccosto = null
					this.ocompra = null
					this.desglose = null
					this.hes = null
				}
			}
		},
		computed: {

			getGiros() { return listas.giros },
			getLastEventType() { return listas.last_event_type },
			getCategorias() { return listas.categorias },
			getBillingPeriod() { return listas.billing_period },
			getSize() { return listas.size },
			getSector() { return listas.sector },
			getComunas() { return listas.comunas },
			getSioNo() { return listas.siono },
			getMetodoPago() { return listas.metodo_pago },
			getPaymentTerms() { return listas.payment_terms },
			getHunterRep() { return listas.hunter_rep },
			getFarmerRep() { return listas.farmer_rep },
			getCollection() { return listas.collection },

		},
		methods: {

			buscarCliente(id) {

				var flag = false
				this.clientes.forEach(function(cliente) {

					if (cliente.CLIENT_ID == id)
					{
						flag = true
						return false
					}
				})

				if (flag)
					this.mensaje = "El Client ID ya existe !!!"


				return flag
			},

			// Se asume que al presionar Refacturar, se cierra la ventana
			guardar() {

				this.mensaje = ""

				var form = $("#agregarClienteForm")[0]
				var data = new FormData(form)
				var seguir = true 
				var datos = {}

				// Valida que no exista el Cliente ID Madre
				if (this.id != "")
				{
					var existe = this.buscarCliente(this.id)

					if (existe)
						return
				}

				// Recorremos los campos del formulario para validar la informacion
				// Si los campos boligatorios tienen valor, SEGUIR es TRUE y se envia la info al servidor
				var that = this
				data.forEach(function(value, key, o) {

					// Seteamos la validacion del campo a NULL (no validado)
					that.$set(that.validado, key, null) 

					// Si el campo es obligatorio, validamos
					var required = $("#" + key).attr("required")
					if (required != undefined)
					{
						if (value == "") {

							// Seteamos la validacion del campo a FALSE (invalido)
							that.$set(that.validado, key, false)

							seguir = false
						} else 
							that.$set(that.validado, key, true)
					}

					// Si el campo tiene validacion de largo, revisamos aqui
					var largo = $("#" + key).attr("largo")
					if (largo != undefined)
					{
						if (value.toString().length < largo)
						{
							// Seteamos la validacion del campo a FALSE (invalido)
							that.$set(that.validado, key, false)

							seguir = false
						}
					}

					// Para pasar a mayusculas el valor
					var upper = $("#" + key).attr("upper")
					if (upper != undefined)
						value = value.toString().toUpperCase()

					datos[key] = value // Guardamos el valor en el objeto que enviaremos al servidor
				})

				// Validacion personalizada
				// Si el campo RECURRENTE es SI, entonces N_OC y VENCIMIENTO_OC son obligatorios
				var rec = $("#RECURRENTE").val()
				if (rec == "SI")
				{
					var n_oc = $("#N_OC").val()
					if (n_oc == "") 
					{
						this.$set(this.validado, "N_OC", false)
						seguir = false
					}

					var v_oc = $("#VENCIMIENTO_OC").val()
					if (v_oc == "") 
					{
						this.$set(this.validado, "VENCIMIENTO_OC", false)

						seguir = false
					}
				}

				var valido = ValidaRut($("#CLIENT_TAX_CODE").val())
				if (!valido) {

					this.$set(this.validado, "CLIENT_TAX_CODE", false)
					seguir = false	
				} else 
					this.$set(this.validado, "CLIENT_TAX_CODE", true)

				if (!seguir)
					return

				// Agregamos los datos faltantes al objeto que enviaremos al servidor 
				datos["USUARIO_CREACION_BS"] = this.$usuario
				datos["F_CREACION_BS"] = moment().format("YYYY-MM-DD HH:mm:ss")
				datos["USUARIO_ACTUALIZACION"] = this.$usuario 
				datos["FECHA_ACTUALIZACION"] = moment().format("YYYY-MM-DD HH:mm:ss")
				datos["@timestamp "] = moment().format("YYYY-MM-DD HH:mm:ss")
				datos["estado"] = "activo"

				// Agregamos los campos faltantes al objeto DATOS, para el envio de info
				this.campos.forEach(function(campo) {

					if (datos[campo.toUpperCase()] == undefined)
						datos[campo.toUpperCase()] = ""
				})

				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "man0",
					"proceso": "newCli",
					"clientes": [ datos ],
				}

				// mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				// Llamada a la API
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)

					this.cerrar()

				}).catch(ex => {

					this.mensaje = ex.message

					// ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})
			},

			cerrar() {

				if (this.onCerrar)
					this.onCerrar()
			},
		}
	}
</script>
<style scoped>

	.content {
		height: 485px;
		/*margin: 10px;*/
		border: 1px solid lightgray;
		background-color: white;
		padding: 10px 10px 10px 10px;
	}

	.data {
		/*width: 100%;*/
		margin-top: 10px;
		padding-bottom: 10px;
		height: Calc(100% - 50px);
		overflow: auto;
	}

	.formulario {
		width: 100%;
		height: auto;
		overflow: auto;
		font-size: 14px;
	}

	.linea {
		margin-top: 3px;
		margin-bottom: 5px;
	}

	.separador {
		margin-bottom: 8px;
	}

</style>
